export default __webpack_public_path__ + "static/media/hvacomdm140-1.0c80ca4e.webp";